import React from 'react';
import { motion } from 'framer-motion';
import Navbar from './Navbar';
import '../../styles/Pricing.css';
import '../../styles/Navbar.css';
import freeImage from '../../assets/FREE.webp';
import preImage from '../../assets/PRE.webp';
import eduImage from '../../assets/EDU.webp';
import freetImage from '../../assets/FREET.webp';
import pretImage from '../../assets/PRET.webp';
import edutImage from '../../assets/EDUT.webp';

const Pricing = () => {
  return (
    <div className="pricing-container">
      <Navbar />
      <div className="pricing-content">
        <div className="pricing-item">
          <motion.img
            src={freeImage}
            alt="Free Plan"
            className="pricing-image"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          />
          <motion.button
            className="image-button"
            initial={{ scale: 0.8 }}
            whileHover={{ scale: 1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <img src={freetImage} alt="Free Plan Button" />
          </motion.button>
        </div>
        <div className="pricing-item">
          <motion.img
            src={preImage}
            alt="Premium Plan"
            className="pricing-image"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          />
          <motion.button
            className="image-button"
            initial={{ scale: 0.8 }}
            whileHover={{ scale: 1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <img src={pretImage} alt="Premium Plan Button" />
          </motion.button>
        </div>
        <div className="pricing-item">
          <motion.img
            src={eduImage}
            alt="Education Plan"
            className="pricing-image"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          />
          <motion.button
            className="image-button"
            initial={{ scale: 0.8 }}
            whileHover={{ scale: 1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness:300 }}
          >
            <img src={edutImage} alt="Education Plan Button" />
          </motion.button>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
